export default "__VITE_ASSET__Wn15sQoj__"